import React from "react";
import css from "./section.module.css";
import {FaCreditCard, FaCalendarCheck, FaCalendarTimes} from 'react-icons/fa'
import Pricing from "./Pricing";
import resources from '../../../../resources/index'

const Section5_2 = () => {
  const pricingData = [
    {
      topColor: "#175CFF",
      bgColor: "#fff",
      priceColor: "#000",
      textColor: "#575757",
      price: "25",
      li1: "1 Team",
      li2: " 1 Installed Agent",
      li3: "1 Attacked Targets Per Month",
    },
    {
      topColor: "#FFB128",
      bgColor: "linear-gradient(90deg,#071c4d,#002d97)",
      priceColor: "#fff",
      textColor: "#d9d9d9",
      price: "45",
      li1: "5 Team",
      li2: " 3 Installed Agent",
      li3: "24 Attacked Targets Per Month",
    },
    {
      topColor: "#175CFF",
      bgColor: "#fff",
      priceColor: "#000",
      price: "75",
      textColor: "#575757",
      li1: "6 Team",
      li2: " 8 Installed Agent",
      li3: "40 Attacked Targets Per Month",
    },
  ];

  return (
    <div className={css.section5}>
    
      <div className={css.section5_div1}>
        <h4>Pricing</h4>
        <h2>Check Our Valuable Price</h2>
        <p>
          Conveniently mesh cooperative services via magnetic outsourcing.
          Dynamically grow value whereas accurate e-commerce vectors.
        </p>
      </div>

      <div className={css.section5_2_icons_wrapper}>
        <div className="col-lg-3">
          <div className={css.section5_2_icon_wrapper}>
            <div
              style={{ backgroundColor: "rgba(23,92,255,.2)", color: 'blue' }}
              className={css.main_icon}
            >
              <FaCreditCard className={`${css.section5_2_icon}`} />
            </div>
            <div
              className={css.main_icon_desc}
            >
              No credit card required
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className={css.section5_2_icon_wrapper}>
            <div
              style={{ backgroundColor: "rgba(92,201,167,.2)", color: 'green' }}
              className={css.main_icon}
            >
              <FaCalendarCheck className={`${css.section5_2_icon} text-primary`} />
            </div>
            <div
              className={css.main_icon_desc}
            >
             Get 30 day free trial
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className={css.section5_2_icon_wrapper}>
            <div
              style={{ backgroundColor: "rgba(242,87,103,.2)", color: 'red' }}
              className={css.main_icon}
            >
              <FaCalendarTimes className={`${css.section5_2_icon} text-primary`} />
            </div>
            <div
              className={css.main_icon_desc}
            >
              Cancel Anytime
            </div>
          </div>
        </div>
      </div>

      <div className={css.pricing}>
        {pricingData.map((data, index) => {
          return <Pricing key={index} data={data} />;
        })}
        <img className={css.dot_img_top_right} src={resources.icons.dots} alt = "User bg"/>
       <img className={css.dot_img_bottom_left} src={resources.icons.dots} alt = "User bg"/>
      </div>

    </div>
  );
};

export default Section5_2;
